import type {ConnectorDraft} from 'src/types/connector';
import type {NodeSchedule} from 'src/types/node-schedule';


export const SET_CONNECTOR_ID = 'connector/set-connector-id';
export const SET_ENDPOINT_ID = 'connector/set-endpoint-id';
export const SET_RECIPIENT_ENTITY_ID_PATH =
  'connector/set-recipient-entity-id-path';
export const SET_VARIABLE_MAPPING = 'connector/set-variable-mapping';
export const SET_SAMPLE_VALUE = 'connector/set-sample-value';
export const SET_SAMPLE_PAYLOAD = 'connector/set-sample-payload';
export const RECEIVE_CONNECTOR = 'connector/receive';
export const UPDATE_NODE_SCHEDULE = 'connector/update-node-schedule';
export const RESET = 'connector/reset';

export type SetConnectorIdAction = {
  type: typeof SET_CONNECTOR_ID;
  payload: {connectorId: number};
};

export type SetEndpointIdAction = {
  type: typeof SET_ENDPOINT_ID;
  payload: {endpointId: number | null};
};

export type SetRecipientEntityIdPathAction = {
  type: typeof SET_RECIPIENT_ENTITY_ID_PATH;
  payload: {recipientEntityIdPath: string | null};
};

export type SetVariableMappingAction = {
  type: typeof SET_VARIABLE_MAPPING;
  payload: {key: string; value: string};
};

export type SetSampleValueAction = {
  type: typeof SET_SAMPLE_VALUE;
  payload: {key: string; value: string};
};

export type SetSamplePayloadAction = {
  type: typeof SET_SAMPLE_PAYLOAD;
  payload: {samplePayload: string};
};

export type ReceiveConnectorAction = {
  type: typeof RECEIVE_CONNECTOR;
  payload: Partial<ConnectorDraft>;
};

export type UpdateNodeScheduleAction = {
  type: typeof UPDATE_NODE_SCHEDULE;
  payload: Partial<NodeSchedule>;
};

export type ResetAction = {type: typeof RESET; payload?: undefined};

export type ConnectorAction =
  | SetConnectorIdAction
  | SetEndpointIdAction
  | SetRecipientEntityIdPathAction
  | SetVariableMappingAction
  | SetSampleValueAction
  | SetSamplePayloadAction
  | ReceiveConnectorAction
  | UpdateNodeScheduleAction
  | ResetAction;

export const setConnectorId = (connectorId: number): SetConnectorIdAction => ({
  type: SET_CONNECTOR_ID,
  payload: {connectorId},
});

export const setEndpointId = (
  endpointId: number | null,
): SetEndpointIdAction => ({
  type: SET_ENDPOINT_ID,
  payload: {endpointId},
});

export const setRecipientEntityIdPath = (
  recipientEntityIdPath: string | null,
): SetRecipientEntityIdPathAction => ({
  type: SET_RECIPIENT_ENTITY_ID_PATH,
  payload: {recipientEntityIdPath},
});

export const setVariableMapping = (
  key: string,
  value: string,
): SetVariableMappingAction => ({
  type: SET_VARIABLE_MAPPING,
  payload: {key, value},
});

export const setSampleValue = (
  key: string,
  value: string,
): SetSampleValueAction => ({
  type: SET_SAMPLE_VALUE,
  payload: {key, value},
});

export const setSamplePayload = (
  samplePayload: string,
): SetSamplePayloadAction => ({
  type: SET_SAMPLE_PAYLOAD,
  payload: {samplePayload},
});

export const receiveConnector = (
  payload: Partial<ConnectorDraft>,
): ReceiveConnectorAction => ({
  type: RECEIVE_CONNECTOR,
  payload,
});

export const updateNodeSchedule = (
  payload: Partial<NodeSchedule>,
): UpdateNodeScheduleAction => ({
  type: UPDATE_NODE_SCHEDULE,
  payload,
});

export const reset = (): ResetAction => ({type: RESET});
